import { createSlice } from "@reduxjs/toolkit";
import { setMenuService } from "./services/setMenuService";
import { RootState } from "./store";

export interface MenuItem {
  menuItemId: string;
  description: string;
  imageUrl?: string;
  name: string;
}

export interface SetMenu {
  Items: MenuItem[];
  description: string;
  displayName: string;
  id: string;
  imageUrl:string;
}

export interface Portion {
  displayName: string;
  additionalCost: number;
}

export interface MenuItemSection {
  displayName: string;
  maxAllowedCount: number;
  isRequired: boolean;
  customItemType: string;
  availableCount?: number;
}

export interface ExtraItem {
  menuItemId?: string;
  displayName: string;
  price: number;
  type: string;
  customItemType?: any;
  maxAllowedCount?: any;
}

export interface CustomMenuItem {
  availableDays: number[];
  isAvailable: boolean | undefined;
  totalItems: number;
  displayName: string;
  imageUrl: string;
  restaurantId: string;
  sections: MenuItemSection[];
  extraItems?: ExtraItem[];
  status: string;
  id: string;
  price: number;
  priceType: string;
  createdAt: {
    _nanoseconds: number;
    _seconds: number;
  };
  allergenInformation?: string[];
  foodAttributes?: string[];
  supportPortionSizes?: boolean;
  portions?: Portion[];
  category?: any;
  quantity?: number;
  portionLabel?: string;
}

interface SetMenuState {
  setMenus: SetMenu[];
  loading: boolean;
  error: any;
}

const initialState: SetMenuState = {
  setMenus: [],
  loading: false,
  error: null,
};

const setMenuSlice = createSlice({
  name: "setMenu",
  initialState,
  reducers: {
    getSetMenusStart(state) {
      state.loading = true;
      state.error = null;
    },
    getSetMenusSuccess(state, action) {
      state.setMenus = action.payload;
      state.loading = false;
      state.error = null;
    },
    getSetMenusFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      setMenuService.endpoints.getMenuListByRestaurantId.matchFulfilled,
      (state, { payload }) => {
        state.setMenus = payload.setMenuList;
      }
    );
  },
});

export const { getSetMenusStart, getSetMenusSuccess, getSetMenusFailure } = setMenuSlice.actions;

export const selectSetMenuById = (state: RootState, id: any) =>
  state.setMenu.setMenus.find((menu: SetMenu) => menu.id === id);

export default setMenuSlice.reducer;
